import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { buildingsByProducedResourceId } from "../../balancing/types/buildingsByProducedResourceId";
export var selectBuildingsWhichProducesResourceIdAvailable = function (state, id) {
    var availableBuildings = selectAllExistingBuildingInfo(state);
    return availableBuildings.filter(function (building) {
        var buildingIdByResource = buildingsByProducedResourceId.get(id);
        if (buildingIdByResource != undefined) {
            return buildingIdByResource.some(function (buildingId) { return building.balancing.id === buildingId; });
        }
        return false;
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingsWhichProducesResourceIdAvailable.ts
// module id = 226
// module chunks = 3